/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
// import requestRaw from '@/utils/request'
import { APICore } from '@/utils/servicesApi'
// const qs = require('qs')
export function createValidation(data) {
  return requestRaw({
    url: APICore() + '/member/registration/create-validation',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function createStored(data) {
  return requestRaw({
    url: APICore() + '/member/registration/create-stored',
    method: 'POST',
    data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/register.js